import React, { ReactNode } from "react";
import { StyleProp, View, ViewStyle } from "react-native";
import { useThemedStyle, StyleFunction } from "../../theme";
import { Text } from "../text";

export function InputLabel(props: {
    children: ReactNode;
    style?: StyleProp<ViewStyle>;
}) {
    const styles = useThemedStyle(styleFunc);

    return (
        <View style={[styles.container, props.style]}>
            <Text style={styles.label} numberOfLines={1} ellipsizeMode="tail">
                {props.children}
            </Text>
        </View>
    );
}

const styleFunc: StyleFunction = theme => ({
    container: {
        marginBottom: theme.spacingScale / 2,
    },
    label: {
        ...theme.fonts.medium,
        color: theme.colors.textDark,
        fontSize: 12,
        lineHeight: 16,
        textTransform: "uppercase",
    },
});
